<template>
  <div class="grids">
    <div class="grids_disease" v-if="gdb3">
      <div class="box" v-for="(item, index) in gridsType" v-if="item.num !== undefined" :key="index" @click="$router.push('/' + systems + '/' + item.id)">
        <div class="item-left">
          <i style="background:#fff;"  :class="['iconfont', item.icon]"></i>
          <p class="name">{{ item.title }}</p>
        </div>
        <div>
          <p class="state" v-if="systems === 'drugType' || systems === 'talentType'">需关注 ( {{ item.num }} )</p>
          <p class="state" v-else>高风险 ( {{ item.num }} )</p>
        </div>
      </div>
    </div>
    <div class="grids_disease" v-if="gdb2">
      <div class="box" v-for="(item, index) in gridsType" :key="index" @click="$router.push('/' + systems + '/' + item.id)">
        <div class="item-left">
          <i :class="['iconfont', item.icon]"></i>
          <p class="name">{{ item.title }}</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['gridsType', 'systems'],
  data () {
    return {
      gdb2: false,
      gdb3: false
    }
  },
  mounted () {
    if (this.util.getLS(this.api.status) === 1) {
      this.gdb3 = true
    } else {
      this.gdb2 = true
    }
  }
}
</script>
<style lang="scss">
  @import "../assets/scss/functions";

  .grids {
    color: #28282a;
    padding: 10px;

    .box {
      display: flex;
      justify-content: space-between;
      float: left;
      width: 49%;
      padding: pxToRem(20px) pxToRem(10px);
      background-color: #fafafa;
      margin-bottom: pxToRem(20px);

      &:nth-child(2n) {
        float: right;
      }

      .item-left {
        display: flex;
        align-items: center;
      }

      .iconfont {
        font-size: pxToRem(65px);
      }

      .name {
        margin-left: pxToRem(5px);
        font-size: pxToRem(25px);
        color: #444;
      }

      .state {
        color: #007aff;
        font-size: pxToRem(18px);
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Grids.vue